"use client";

import { usePathname, Link } from "@/i18n/routing";
import { useLocale } from "next-intl";

export default function LanguageSwitcher() {
  const pathname = usePathname();
  const currentLocale = useLocale();

  const languages = [
    { code: "en", label: "English" },
    { code: "si", label: "සිංහල" },
    { code: "ta", label: "தமிழ்" },
  ];

  return (
    <div className="flex items-center gap-0.5 text-white font-poppins text-sm px-2 py-0.5 rounded-3xl border-2 border-purple-400/30">
      {languages.map((lang, index) => (
        <div key={lang.code} className="flex items-center gap-0.5">
          <Link
            href={pathname}
            locale={lang.code}
            className={`transition-all duration-200 hover:text-purple-400 px-1.5 py-0.5 rounded-full ${
              currentLocale === lang.code ? "text-purple-400 font-semibold bg-white/5" : "text-gray-400"
            }`}
          >
            {lang.label}
          </Link>
          {index < languages.length - 1 && (
            <span className="text-gray-600/60 text-xs">|</span>
          )}
        </div>
      ))}
    </div>
  );
}
